module.exports = __webpack_public_path__ + "static/media/UnlockUnclick.9ed656e4.svg";